import { Box, Popover } from '@mui/material';
import { ContentTile, Maybe, NavigationGroup, NavigationLink as NavigationLinkItem } from '@/graphql/__generated/sdk';
import { FeaturedLinkRender } from './GroupNavItem';
import { subNavDropMenuStyles, subNavGridStyles, subNavColumnsGridStyles, subNavContentTilesStyles, getSubNavColumnStyles, getSubNavColumnTitleLinkStyles, getSubNavLinkStyles } from './GroupNavItem.styles';
import HeaderContentTile from './HeaderContentTile';
import NavigationLink from '@shared-components/components/NavigationLink/NavigationLink';
interface IGroupNavDesktopMenu {
  groupMenuId: string;
  open: boolean;
  toolbarRef?: React.RefObject<HTMLDivElement>;
  onClose: (event: React.MouseEvent<HTMLElement>) => void;
  contentTiles?: Array<Maybe<ContentTile>>;
  featuredLink?: Maybe<NavigationLinkItem>;
  subNavGroups?: Array<Maybe<NavigationGroup>>;
}
export const SubNavColumnRender = ({
  subNavGroup
}: {
  subNavGroup: any;
}) => {
  return subNavGroup.map((group, groupIndex) => group && <Box data-testid={`nav_group_column_${group.groupLink?.sys.id ?? groupIndex}`} key={group.groupLink?.sys.id ?? groupIndex} sx={getSubNavColumnStyles()}>
					{group.groupLink?.linkText && <NavigationLink {...group.groupLink} isInternal={Boolean(group.groupLink.isInternal)} itemIndex={0} dataTestId={`link_navlink_nav_group_title_${group.groupLink.sys.id}`} disableUnderline navLinkSx={getSubNavColumnTitleLinkStyles()} />}
					{group.linksCollection?.items?.map((navItem, index) => navItem && <NavigationLink key={navItem.sys.id} {...navItem} isInternal={Boolean(navItem.isInternal)} itemIndex={index} dataTestId={`link_navlink_nav_group_${groupIndex}_item_${navItem.sys.id}`} disableUnderline navLinkSx={getSubNavLinkStyles()} />)}
				</Box>);
};
export default function GroupNavDesktopMenu({
  groupMenuId,
  open,
  toolbarRef,
  onClose,
  contentTiles,
  subNavGroups,
  featuredLink
}: Readonly<IGroupNavDesktopMenu>) {
  return <Popover id={groupMenuId} disableScrollLock open={open} anchorEl={toolbarRef?.current} onClose={onClose} sx={subNavDropMenuStyles} transitionDuration={1} marginThreshold={0} anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'left'
  }} transformOrigin={{
    vertical: 'top',
    horizontal: 'left'
  }} data-sentry-element="Popover" data-sentry-component="GroupNavDesktopMenu" data-sentry-source-file="GroupNavDesktopMenu.tsx">
			<Box data-testid="nav_group_grid" sx={subNavGridStyles} data-sentry-element="Box" data-sentry-source-file="GroupNavDesktopMenu.tsx">
				{featuredLink && <Box data-testid="nav_group_featured_link" sx={{
        gridColumn: '1 / -1'
      }}>
						<FeaturedLinkRender featuredLink={featuredLink} isMobile={false} />
					</Box>}
				<Box data-testid="nav_group_columns" sx={subNavColumnsGridStyles} data-sentry-element="Box" data-sentry-source-file="GroupNavDesktopMenu.tsx">
					{subNavGroups && <SubNavColumnRender subNavGroup={subNavGroups} />}
				</Box>
				{Boolean(contentTiles?.length) && <Box data-testid="nav_group_content_tiles" sx={subNavContentTilesStyles}>
						{contentTiles?.map(tile => tile && <HeaderContentTile key={tile.sys.id} tile={tile} />)}
					</Box>}
			</Box>
		</Popover>;
}